import {
  createVisionRuleEndPoint,
  deleteVisionRuleEndPoint,
  enabledisableVisionRuleEndPoint,
  fetchv1DeviceDetailsEndPoint,
  fetchVisionRulesEndPoint,
  updateVisionRuleEndPoint,
  bulkDeleteVisionRuleEndPoint,
} from "../configuration";
import axiosInstance from "../global/axiosInterceptor";
import {
  converMinutetoSeconds,
  getCompareSymbol,
  getLastSecThirdWords,
  getLastWord,
  validateCondition,
} from "../global/utility/Utils";

export const createRule = async ({
  activeSession,
  roiId,
  cvAppId,
  cvAppName,
  severity,
  groups,
  cameraId,
  selectedDays,
  startTime,
  endTime,
  ruleName,
  sms,
  email,
  triggerData,
  showTimeFrame,
  duration,
  expression,
  fovid,
  companionid,
  deploymentid,
  cvappImage,
  customerMessage,
  title,
  aggregateRule,
  deviceIds,
  foreignIds,
  tagid,
  eventinfo,
  EEAppName,
  addUnits,
  isParking,
  result,
  addCoolDownPeriod,
  coolPeriodValue,
  location,
  isEventApp,
  globalExpression,
  timeZone,
  captureVideoEvidence,
}) => {
  const accountId = activeSession.accountId;
  const finalExpression =
    addUnits === true
      ? `@.eventMsg.fields.${expression} ${getCompareSymbol(
          triggerData?.condition
        )} ${converMinutetoSeconds(triggerData?.value, triggerData?.time)}`
      : triggerData?.condition?.length > 0
      ? `@.eventMsg.fields.${expression} ${getCompareSymbol(
          triggerData?.condition
        )} ${isParking == true ? result : triggerData?.value}`
      : `@.eventMsg.fields.${expression} == 'Unresolved'`;
  const aggregateExpression =
    aggregateRule == true && isParking == true
      ? `@.additionalProperties.sumResult ${getCompareSymbol(
          triggerData?.condition
        )} ${result} && @.eventMsg.fields.${expression}`
      : aggregateRule == true && !isParking
      ? `@.additionalProperties.sumResult ${getCompareSymbol(
          triggerData?.condition
        )} ${triggerData?.value} && @.eventMsg.fields.${expression}`
      : finalExpression;

  try {
    const response = await axiosInstance.post(createVisionRuleEndPoint(), {
      accountname: accountId,
      deviceid: roiId,
      "email-subject": `${severity} alert for ${cvAppName}`,
      "email-to": "",
      contactGroup: groups,
      "sms-to": "",
      cameraId: cameraId,
      name: ruleName,
      severity: severity,
      serviceid: cvAppId,
      appName: cvAppName,
      timeFrame: selectedDays,
      starttime: startTime,
      endtime: endTime,
      smsNotification: sms,
      emailNotification: email,
      condition:
        triggerData?.condition?.length > 0
          ? `${cvAppName} ${triggerData?.condition} ${triggerData?.value}`
          : `${cvAppName} ${"Detected"}`,
      showTimeFrame: showTimeFrame,
      expression: aggregateExpression,
      fovid: fovid,
      cvappImage: cvappImage,
      companionid: companionid,
      deploymentid: deploymentid,
      customerMessage: customerMessage,
      title: title,
      aggregateRule: aggregateRule,
      foreignIds: foreignIds,
      deviceIds: deviceIds,
      tagid: Array.isArray(tagid) ? tagid : [tagid],
      cvAppValue: expression,
      eventinfo: eventinfo,
      addDuration: false,
      duration: duration,
      EEAppName: EEAppName,
      addUnits: addUnits,
      addCoolDownPeriod: addCoolDownPeriod,
      coolPeriodValue: coolPeriodValue,
      location: location,
      isEventApp: isEventApp,
      globalExpression: globalExpression,
      time_zone: timeZone,
      captureVideoEvidence: captureVideoEvidence ?? true,
    });
    const ruleRes = response.data;
    return ruleRes;
  } catch (error) {
    console.error("Getting error while trying to create alert", error);
    return error.response;
  }
};

export const CreateRuleinRoi = async (payload) => {
  try {
    const accountId = payload.activeSession.accountId;
    const finalExpression =
      payload.addUnits === true
        ? `@.eventMsg.fields.${payload.expression} ${getCompareSymbol(
            payload?.conditionOperator
          )} ${converMinutetoSeconds(
            payload.triggerData?.value,
            payload.triggerData?.time
          )}`
        : validateCondition(payload.conditionOperator)
        ? `@.eventMsg.fields.${payload.expression} ${getCompareSymbol(
            payload?.conditionOperator
          )} ${payload?.conditionValue}`
        : `@.eventMsg.fields.${payload.expression} == 'Unresolved'`;
    const response = await axiosInstance.post(createVisionRuleEndPoint(), {
      accountname: accountId,
      deviceid: payload.roiid,
      serviceid: payload.cvappId ? payload.cvappId : payload.cvappid,
      appName: payload.cvAppName,
      severity: payload.severity,
      timeFrame: payload.timeFrame,
      contactGroup: Array.isArray(payload.groups)
        ? payload.groups?.join(",")
        : payload.groups,
      starttime: payload.startTime,
      endtime: payload.endTime,
      time_zone: payload?.timeZone,
      captureVideoEvidence: payload?.captureVideoEvidence,
      name: payload.ruleName,
      smsNotification: payload.sms,
      emailNotification: payload.email,
      cameraId: payload.cameraId,
      condition: validateCondition(payload.conditionOperator)
        ? `${payload.cvAppName} ${payload.conditionOperator} ${payload.conditionValue}`
        : `${payload.cvAppName} ${"Detected"}`,
      showTimeFrame: payload.showTimeFrame,
      "email-subject": `${payload.severity} alert for ${payload.cvAppName}`,
      "email-to": "",
      "sms-to": "",
      fovsnapshot: payload.fovsnapshot,
      expression: finalExpression,
      cvappImage: payload.cvappImage,
      fovid: payload.fovid,
      companionid: payload.companionid,
      deploymentid: payload.deploymentid,
      customerMessage: payload.customerMessage,
      title: payload.title,
      aggregateRule: payload.aggregateRule,
      eventinfo: payload.eventinfo,
      addDuration: false,
      duration: payload.duration,
      cvAppValue: payload.expression,
      EEAppName: payload.EEAppName,
      addUnits: payload.addUnits,
      addCoolDownPeriod: payload.addCoolDownPeriod,
      coolPeriodValue: payload.coolPeriodValue,
      location: payload.location,
      tagid: Array.isArray(payload.tagid) ? payload.tagid : [payload.tagid],
      isEventApp: payload.isEventApp,
    });
    const ruleRes = response.data;
    return ruleRes;
  } catch (error) {
     console.error("Getting error while trying to create alert", error);
    return error.response;
  }
};

export const updateRule = async ({
  activeSession,
  roiId,
  cvappId,
  severity,
  groups,
  cameraId,
  ruleId,
  ruleName,
  selectedDays,
  sms,
  email,
  showTimeFrame,
  startTime,
  endTime,
  conditionOperator,
  conditionValue,
  cvAppName,
  duration,
  fovsnapshot,
  expression,
  fovid,
  companionid,
  deploymentid,
  cvappImage,
  customerMessage,
  title,
  tagid,
  aggregateRule,
  deviceIds,
  foreignIds,
  eventinfo,
  EEAppName,
  addUnits,
  triggerData,
  addCoolDownPeriod,
  coolPeriodValue,
  isParking,
  result,
  location,
  isEventApp,
  globalExpression,
  isVideoEvidenceCapture,
  timeZone
}) => {
  try {
    const accountId = activeSession.accountId;
    const finalExpression =
      addUnits === true
        ? `@.eventMsg.fields.${expression} ${getCompareSymbol(
            conditionOperator
          )} ${converMinutetoSeconds(conditionValue, triggerData?.time)}`
        : validateCondition(conditionOperator)
        ? `@.eventMsg.fields.${expression} ${getCompareSymbol(
            conditionOperator
          )} ${isParking == true ? result : conditionValue}`
        : `@.eventMsg.fields.${expression} == 'Unresolved'`;
    const aggregateExpression =
      aggregateRule == true && isParking == true
        ? `@.additionalProperties.sumResult ${getCompareSymbol(
            conditionOperator
          )} ${result} && @.eventMsg.fields.${expression}`
        : aggregateRule == true && !isParking
        ? `@.additionalProperties.sumResult ${getCompareSymbol(
            conditionOperator
          )} ${conditionValue} && @.eventMsg.fields.${expression}`
        : finalExpression;
    const response = await axiosInstance.patch(updateVisionRuleEndPoint(), {
      accountname: accountId,
      deviceid: roiId,
      "email-subject": `${severity} alert for ${cvAppName}`,
      "email-to": "",
      contactGroup: groups,
      "sms-to": "",
      severity: severity,
      cameraId: cameraId,
      ruleid: ruleId,
      name: ruleName,
      serviceid: cvappId,
      appName: cvAppName,
      timeFrame: selectedDays,
      smsNotification: sms,
      emailNotification: email,
      showTimeFrame: showTimeFrame,
      starttime: startTime,
      endtime: endTime,
      condition: validateCondition(conditionOperator)
        ? `${cvAppName} ${conditionOperator} ${conditionValue}`
        : `${cvAppName} ${"Detected"}`,
      fovsnapshot: fovsnapshot,
      expression: aggregateExpression,
      cvappImage: cvappImage,
      fovid: fovid,
      companionid: companionid,
      deploymentid: deploymentid,
      customerMessage: customerMessage,
      title: title,
      aggregateRule: aggregateRule,
      tagid: Array.isArray(tagid) ? tagid : [tagid],
      cvAppValue: expression,
      foreignIds: foreignIds,
      deviceIds: deviceIds,
      eventinfo: eventinfo,
      addDuration: false,
      duration: duration,
      EEAppName: EEAppName,
      addUnits: addUnits,
      addCoolDownPeriod: addCoolDownPeriod,
      coolPeriodValue: coolPeriodValue,
      location: location,
      isEventApp: isEventApp,
      globalExpression: globalExpression,
      captureVideoEvidence: isVideoEvidenceCapture ?? true,
      time_zone: timeZone,
    });
    const ruleRes = response.data;
    return ruleRes;
  } catch (error) {
    console.error("Getting error while trying to update alert", error);
    return error.response;
  }
};

export const fetchRules = async (activeSession) => {
  try {
    const accountId = activeSession.accountId;
    const fetchedRules = await axiosInstance.post(fetchVisionRulesEndPoint(), {
      accountname: accountId,
      filter: { $sort: [{ field: "createdon", order: "desc" }] },
    });
    return fetchedRules.data;
  } catch (error) {
    console.error("Getting error while trying to fetch alerts", error);
    return error.response;
  }
};

export const deleteRule = async (activeSession, ruleid) => {
  try {
    const response = await axiosInstance.delete(deleteVisionRuleEndPoint(), {
      data: {
        accountname: activeSession.accountId,
        resourceidentifier: {
          id: ruleid,
        },
      },
    });
    return response;
  } catch (error) {
    console.error("Getting following error while trying to delete alert", error);
    return error.response;
  }
};

export const deleteBulkRule = async (activeSession, ruleids) => {
  if (!ruleids || !Array.isArray(ruleids) || ruleids.length === 0) {
    throw new Error("ruleids must be a non-empty array");
  }
  try {
    const response = await axiosInstance.post(bulkDeleteVisionRuleEndPoint(), {
        accountname: activeSession.accountId,
        ruleids: ruleids
    });
    return response;
  } catch (error) {
    console.error("Getting following error while trying to delete alert", error);
    return error.response;
  }
};



export const enabledisableRule = async (activeSession, ruleid, e) => {
  try {
    const response = await axiosInstance.patch(
      enabledisableVisionRuleEndPoint(),
      {
        accountname: activeSession.accountId,
        resourceidentifier: {
          id: ruleid,
        },
        rule: {
          disabled: e,
        },
      }
    );
    const res = response.data;
    return res;
  } catch (error) {
    console.error(
      "Getting following error while trying to disable/enable alert",
      error
    );
    throw error;
  }
};

export const getVirtualDeviceId = async (activeSession, tagid, cvappimage) => {
  try {
    const response = await axiosInstance.post(fetchv1DeviceDetailsEndPoint(), {
      accountname: activeSession.accountId,
      filter: {
        $selection: {
          kind: "ts.device.roi.grouping",
          name: `${tagid}_${cvappimage}`,
        },
      },
    });
    const res = response.data;
    return res;
  } catch (error) {
    console.error(
      "Getting following error while trying to fetch visual id",
      error
    );
    return error.response;
  }
};
